import axios from 'axios';

const BASE_URL: string | undefined = process.env.REACT_APP_ENDPOINT || "https://ms-micrositios-gasco-bff-nestjs-4stcvuvlha-uc.a.run.app"; // NOSONAR

export default axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
    // 'x-api-key': API_KEY
  },
});
